<template>
  <div class="changePayPwd">
    <div class="edit">
      <p class="title">修改支付密码</p>
      <el-form :model="info" :rules="rules" ref="info" label-width="100px" class="demo-ruleForm">
        <el-form-item
                label="手机号："
                prop="mobile"
        >
          <el-input v-model="info.mobile" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item
                label="图形验证码："
                prop="oldMobile"
        >
          <el-input v-model="vxOpenId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
        >
          <div class="imgCode" >
            <div class="left">
              <img :src="codeImg" alt="">
            </div>
            <div class="right">
              <p>请把左边验证码输入框中</p>
              <p @click="getImgCode">看不清，换一张</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item
                label="验证码："
                prop="code"
        >
          <el-input class="code" v-model="info.code" autocomplete="off" placeholder="请输入验证码"></el-input>
          <el-button :disabled="!rightPhone" class="codeBtn" :class="{right: rightPhone}" @click.prevent="send">{{computeTime ? `${computeTime}秒后重新获取` : '获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item
                label="密码："
                prop="pwd"
        >
          <el-input v-model="info.pwd" type="password" autocomplete="off" placeholder="请输入您的密码"></el-input>
        </el-form-item>
        <el-form-item
                label="确认密码："
                prop="pwd2"
        >
          <el-input v-model="info.pwd2" type="password" autocomplete="off" placeholder="请再一次确定密码"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="btn" @click="submitForm('info')">提交</el-button>
        </el-form-item>
      </el-form>
      <img class="icon" src="../../assets/images/courier/close.png" alt="" @click="close">
    </div>
  </div>
</template>

<script>
  import {reqSend, reqCode, reqChangePayPwd} from '../../api'
  export default {
    data () {
      let validPhone = (rule, value, callback) => {
        let reg = /^1[3456789]\d{9}$/
        if(!reg.test(value)){
          callback(new Error('手机号码不正确'))
        }else{
          callback()
        }
      }
      let validPwd2 = (rule, value, callback) => {
        if (value !== this.info.pwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }
      return {
        info:{
          mobile	: '',
          pwd: '',
          pwd2: '',
          code: '', // 短信验证码
        },
        vxOpenId: '', // 图形验证码内容
        codeImg:'', // 图形验证码图片
        computeTime:0, // 计时
        rules: {
          mobile:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
          pwd:[
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min:6, max:6, message: '长度为6位', trigger: 'blur'}
          ],
          pwd2:[
            { required: true, message: '请再次确认密码', trigger: 'blur' },
            {validator: validPwd2, trigger: 'blur'},
            { min:6, max:6, message: '长度为6位', trigger: 'blur'}
          ],
          code:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
        }
      }
    },
    created() {
      //获取图形验证码
      this.getImgCode()
    },
    methods: {
      //获取图形验证码
      getImgCode () {
        this.codeImg = 'http://app.yixian-express.com/api/pictureCode/out?time='+ new Date()
      },
      // 关闭
      close () {
        this.$emit('closePay')
      },
      //发送验证码
      send () {
        if (this.vxOpenId) {
          if (!this.computeTime) {
            //  异步发送验证码
            const data = `?mobile=${this.info.mobile}&type=RESETPAYPWD&code=${this.vxOpenId}`
            reqSend(data).then(res => {
              console.log(res)
              if (res.code === 200) {
                this.computeTime = 60
                const timer = setInterval(() => {
                  this.computeTime--
                  if (this.computeTime <= 0) {
                    clearInterval(timer)
                  }
                }, 1000)
              } else if (res.code === 500) {
                this.$message({
                  type: 'error',
                  message: res.data.errMsg
                })
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: '请先输入图形验证码'
          })
        }
      },
      // 提交信息
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const query = `?mobile=${this.info.mobile}&pwd=${this.info.pwd}&code=${this.info.code}`
            reqChangePayPwd(query).then(res => {
              if(res.code === 200){
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.$emit('closePay')
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    computed: {
      //监听手机号是否正确
      rightPhone () {
        return /^1[3456789]\d{9}$/.test(this.info.mobile)
      },
    }
  }
</script>

<style scoped lang="less" type="text/less">
  .changePayPwd{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 1000;
    .edit{
      position: relative;
      margin:50px auto;
      padding:50px 0 30px;
      width: 540px;
      box-sizing: border-box;
      background: #fff;
      .title{
        margin-bottom: 43px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #2c2c2c;
      }
      .demo-ruleForm{
        padding:0 44px;
        .imgCode{
          display: flex;
          .left{
            img{
              display: block;
              width: 175px;
              height: 60px;
              margin-right: 21px;
              background: #eee;
            }
          }
          .right{
            p{
              line-height: 30px;
              &:last-of-type{
                color:#2fa1de;
                cursor: pointer;
              }
            }
          }
        }
        .code{
          width: 206px;
        }
        .codeBtn{
          width: 141px;
          background: #ccc;
          color: #fff;
          &.right{
            background: #61aee6;
          }
        }
        .btn{
          display: block;
          width: 200px;
          height: 46px;
          margin:20px auto 0;
          background: #61aee6;
          border-radius: 23px;
          font-size: 16px;
          font-weight: bold;
          border:none;
          color: #ffffff;
        }
      }
      .icon{
        position: absolute;
        top: 13px;
        right: 16px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Person/ChangePayPwd.vue